import { Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { SupplierSpecialOffer } from '../supplier-special-offer';
import { SupplierSpecialOfferDto } from '../dto/supplier-special-offer-dto';

export const mapSupplierSpecialOffer = (locales: Locale[], offer: SupplierSpecialOfferDto): SupplierSpecialOffer => ({
    id: offer.id,
    title: getLocalizedString(locales, offer.title),
    subtitle: getLocalizedString(locales, offer.subtitle),
    image: offer.image,
    path: offer.path?.trim().replace(/^\/+|\/+$/g, ''), // trim and remove leading and trailing slashes
    supplier: {
        id: offer.supplier.id,
        image: offer.supplier.image,
        name: offer.supplier.name,
    },
    validTo: new Date(offer.validTo),
});
